import React from 'react';
function PenIcon() {
  return (
    <svg width="60" height="60" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="32" height="32" rx="16" fill="#EBE9FE" />
      <path
        d="M19.0625 9.26953C19.6641 8.66797 20.6211 8.66797 21.2227 9.26953L22.4805 10.5273C23.082 11.1289 23.082 12.0859 22.4805 12.6875L20.9492 14.2188L17.5312 10.8008L19.0625 9.26953ZM20.4023 14.875L19.1445 19.0859C18.9805 19.6328 18.5703 20.043 18.0234 20.2344L10.8047 22.668C10.4766 22.75 10.1484 22.6953 9.90234 22.4492L14.1133 18.2656C14.2773 18.3477 14.4688 18.375 14.6602 18.375C15.3984 18.375 15.9727 17.8008 15.9727 17.0625C15.9727 16.3516 15.3984 15.75 14.6602 15.75C13.9492 15.75 13.3477 16.3516 13.3477 17.0625C13.3477 17.2812 13.4023 17.4727 13.4844 17.6367L9.30078 21.8477C9.05469 21.6016 8.97266 21.2734 9.08203 20.9453L11.5156 13.7266C11.6797 13.1797 12.1172 12.7695 12.6641 12.6055L16.8477 11.3477L20.4023 14.875Z"
        fill="#622FEE"
      />
    </svg>
  );
}

export default PenIcon;
